export class ApiError extends Error {
  readonly status: number;

  /**
   * The BFF's `detail` message when one is present in the error body (FastAPI's
   * `{ "detail": "…" }`). The write UI surfaces this verbatim on a 422 (illegal
   * edge) so the operator sees the actionable reason — never collapsed into a
   * generic "service down" message. `null` when the body carried no detail.
   */
  readonly detail: string | null;

  /**
   * The full parsed error body, when it was JSON (e.g. `ManualLeadConflict`'s
   * `existing_lead_id` on a 409). `null` on an empty/non-JSON body. Callers that
   * need more than `detail` (the 409 duplicate-lead link) read this.
   */
  readonly body: unknown;

  constructor(status: number, message: string, detail: string | null = null, body: unknown = null) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.detail = detail;
    this.body = body;
  }
}
